import {
  getPreShopsData,
  downloadPreShopData,
  getPreShopDetailData,
  editPreShopData
} from '../libs/apis/PreShopApi';

export const GET_PRE_SHOPS_REQUEST = 'GET_PRE_SHOPS_REQUEST';
export const GET_PRE_SHOPS_SUCCESS = 'GET_PRE_SHOPS_SUCCESS';
export const GET_PRE_SHOPS_FAILURE = 'GET_PRE_SHOPS_FAILURE';

export const DOWNLOAD_PRE_SHOP_REQUEST = 'DOWNLOAD_PRE_SHOP_REQUEST';
export const DOWNLOAD_PRE_SHOP_SUCCESS = 'DOWNLOAD_PRE_SHOP_SUCCESS';
export const DOWNLOAD_PRE_SHOP_FAILURE = 'DOWNLOAD_PRE_SHOP_FAILURE';

export const GET_PRE_SHOP_DETAIL_REQUEST = 'GET_PRE_SHOP_DETAIL_REQUEST';
export const GET_PRE_SHOP_DETAIL_SUCCESS = 'GET_PRE_SHOP_DETAIL_SUCCESS';
export const GET_PRE_SHOP_DETAIL_FAILURE = 'GET_PRE_SHOP_DETAIL_FAILURE';
export const CLEAR_PRE_SHOP_DETAIL = 'CLEAR_PRE_SHOP_DETAIL';

export const EDIT_PRE_SHOP_REQUEST = 'EDIT_PRE_SHOP_REQUEST';
export const EDIT_PRE_SHOP_SUCCESS = 'EDIT_PRE_SHOP_SUCCESS';
export const EDIT_PRE_SHOP_FAILURE = 'EDIT_PRE_SHOP_FAILURE';

export const ADD_PRE_SHOP_IMAGE_REQUEST = 'ADD_PRE_SHOP_IMAGE_REQUEST';
export const ADD_PRE_SHOP_IMAGE_SUCCESS = 'ADD_PRE_SHOP_IMAGE_SUCCESS';
export const ADD_PRE_SHOP_IMAGE_FAILURE = 'ADD_PRE_SHOP_IMAGE_FAILURE';

export const COUNT_PRE_SHOP_NAME_REQUEST = 'COUNT_PRE_SHOP_NAME_REQUEST';
export const COUNT_PRE_SHOP_NAME_SUCCESS = 'COUNT_PRE_SHOP_NAME_SUCCESS';
export const COUNT_PRE_SHOP_NAME_FAILURE = 'COUNT_PRE_SHOP_NAME_FAILURE';

export const COUNT_PRE_SHOP_PHONE_REQUEST = 'COUNT_PRE_SHOP_PHONE_REQUEST';
export const COUNT_PRE_SHOP_PHONE_SUCCESS = 'COUNT_PRE_SHOP_PHONE_SUCCESS';
export const COUNT_PRE_SHOP_PHONE_FAILURE = 'COUNT_PRE_SHOP_PHONE_FAILURE';

export const getPreShops = params => dispatch => {
  dispatch({ type: GET_PRE_SHOPS_REQUEST });
  return getPreShopsData(params)
    .then(response =>
      dispatch({
        type: GET_PRE_SHOPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_PRE_SHOPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadPreShop = params => dispatch => {
  dispatch({ type: DOWNLOAD_PRE_SHOP_REQUEST });
  return downloadPreShopData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_PRE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_PRE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getPreShopDetail = (preShopId, params) => dispatch => {
  dispatch({ type: GET_PRE_SHOP_DETAIL_REQUEST });
  return getPreShopDetailData(preShopId, params)
    .then(response =>
      dispatch({
        type: GET_PRE_SHOP_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_PRE_SHOP_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const clearPreShopDetail = () => dispatch => {
  dispatch({ type: CLEAR_PRE_SHOP_DETAIL });
};

export const editPreShop = (preShopId, params) => dispatch => {
  dispatch({ type: EDIT_PRE_SHOP_REQUEST });
  return editPreShopData(preShopId, params)
    .then(response =>
      dispatch({
        type: EDIT_PRE_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_PRE_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const countPreShopName = params => dispatch => {
  dispatch({ type: COUNT_PRE_SHOP_NAME_REQUEST });
  return getPreShopsData(params)
    .then(response =>
      dispatch({
        type: COUNT_PRE_SHOP_NAME_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: COUNT_PRE_SHOP_NAME_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const countPreShopPhone = params => dispatch => {
  dispatch({ type: COUNT_PRE_SHOP_PHONE_REQUEST });
  return getPreShopsData(params)
    .then(response =>
      dispatch({
        type: COUNT_PRE_SHOP_PHONE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: COUNT_PRE_SHOP_PHONE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
